import React from 'react';

import Link from 'next/link';

import { H5 } from '@repo/ui/components/Typography';

import { FlexColumn } from 'styles/layouts';

import TextBlock from '../TextBlock/TextBlock';

import {
  ButtonHover,
  ButtonEdit,
  Image,
  ImageWrapper,
  Title,
  TextBlockWrapper,
} from './styles';
import { MediaCardProps } from './types';

export const MediaCard: React.FC<MediaCardProps> = ({
  title,
  url,
  image,
  height,
  description,
  titleSize,
  backgroundColor,
  aspectRatio,
  icon,
  buttonLabel,
  onClick,
}) => {
  const cardRow = (
    <FlexColumn gap="16px">
      <ImageWrapper
        aspectRatio={aspectRatio}
        backgroundColor={backgroundColor}
        height={height}
        showOverlayOnHover={!!buttonLabel}
      >
        {icon && <ButtonEdit>{icon}</ButtonEdit>}
        <Image
          fill
          alt={image.alt ?? 'Media card image'}
          provider={image.provider}
          src={image.url}
        />
        {buttonLabel && (
          <ButtonHover>
            <H5>{buttonLabel}</H5>
          </ButtonHover>
        )}
      </ImageWrapper>
      {!!title && (
        <Title $size={titleSize}>
          <b>{title}</b>
        </Title>
      )}
      {description && (
        <TextBlockWrapper>
          <TextBlock paragraphType="p2" text={description} />
        </TextBlockWrapper>
      )}
    </FlexColumn>
  );

  if (url) {
    return (
      <Link href={url} target="_blank" onClick={onClick}>
        {cardRow}
      </Link>
    );
  } else {
    return cardRow;
  }
};
